import { Link } from 'react-router-dom'
import BrandLogo from '../components/BrandLogo'

/**
 * Landing page when OAuth matched no organization (`/oauth/denied` or
 * `/:orgSlug/oauth/denied`). Reject-by-default: no user or identity row was
 * created. Access requires an admin invitation (or an allowlist entry); the
 * next matching sign-in then provisions an active account.
 */
export default function OAuthDenied() {
  return (
    <div className="min-h-screen app-sky flex items-center justify-center px-4">
      <div className="w-full max-w-md mx-auto text-center">
        <BrandLogo size={64} src="/icon-256.png" className="mx-auto rounded-2xl mb-6" />
        <h1 className="text-2xl font-bold text-harbor-text">Access not granted</h1>
        <p className="text-harbor-text-secondary mt-3">
          This sign-in isn&apos;t approved for any organization yet. Ask your ContextHarbor admin to
          invite your email, then try signing in again.
        </p>
        <Link
          to="/login"
          className="inline-block mt-8 px-5 py-2.5 bg-emerald-600 text-white font-medium rounded-lg hover:bg-emerald-700 transition-colors"
        >
          Back to sign in
        </Link>
      </div>
    </div>
  )
}
